import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { HandleSaveSettings } from './HandleSaveSettings';
import { Post } from 'Xhr/Xhr';

export const SubmitFn = (data, confirm_msg) => {
  const savedData = HandleSaveSettings(data);


 

  SwalAlert('warning', confirm_msg, true, () => {
    Post(
      'POST',
      `${process.env.REACT_APP_API_URL_API_SAVE_MAINPAGE_CONFIG}`,
      true,
      {
        ListConfig: savedData,
      }
    )
      .then((response) => {
        if (response.data.resCode === 1) {
          localStorage.removeItem('userColors');
          localStorage.removeItem('icons');
          SwalAlert(
            'success',
            response.data.resMessage,
            false
          );
        }
      })
      .then(() => {
        const timeOut = setTimeout(() => {
          location.reload();
        }, 1000);
      });
  });
};
